import {
  PreferenceScope,
  type UserPreferenceKey,
  type UserPreferences,
} from '../types';

type Taxonomies = UserPreferences[UserPreferenceKey.Taxonomies];

/**
 * The taxonomy preference is a single GLOBAL choice, but Adaptive can only
 * resolve where a company selection anchors it (the reducer's
 * `deriveAdaptiveTaxonomies` requires a COMPANY tree filter). Everywhere else an
 * 'adaptive' choice silently falls back to the Generic taxonomy
 * ({ default: true } role / 0 skill). Call this wherever the stored
 * preference is turned into filter state; never persist the derived value.
 */
export function deriveEffectiveTaxonomiesForScope(
  taxonomies: Taxonomies | undefined,
  scope: PreferenceScope
): Taxonomies | undefined {
  if (!taxonomies || scope === PreferenceScope.COMPANY) {
    return taxonomies;
  }
  const derived: Taxonomies = { ...taxonomies };
  if (derived.role === 'adaptive') {
    derived.role = { default: true };
    delete derived.effectiveRoleTaxonomySelection;
  }
  if (derived.skill === 'adaptive') {
    derived.skill = 0;
    delete derived.effectiveSkillTaxonomySelection;
  }
  if (derived.activity === 'adaptive') {
    derived.activity = 0;
    delete derived.effectiveActivityTaxonomySelection;
  }
  return derived;
}
